const list = () => import('./list');
const info = () => import('./info');
const edit = () => import('./edit');
const brand = () => import('./brand');

const activityRouter = [
  {
    path: '/activity/list', name: 'activityDataList', component: list, meta: { c: 'activity', a: 'list' }
  },
  {
    path: '/activity/info/:id', name: 'activityInfo', component: info, meta: { c: 'activity', a: 'info' }
  },
  {
    path: '/activity/edit/:id', name: 'activityEdit', component: edit, meta: { c: 'activity', a: 'edit' }
  },
  {
    path: '/activity/brand', name: 'activityBrand', component: brand, meta: { c: 'activity', a: 'brand' }
  },
];

export default activityRouter;
